import { ButtonBase } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const PersonaButtonSkeleton = ({ className }) => {
  const styles = useStyles();

  return (
    <ButtonBase
      className={cx(styles.root, className)}
      data-testid="personaButtonSkeleton"
    >
      <div>
        <Skeleton
          className={cx(styles.skeleton, styles.circular)}
          variant="circle"
          animation="wave"
          width={42}
          height={42}
        />
      </div>

      <div className={styles.topTextWrapper}>
        <Skeleton
          className={cx(styles.skeleton, styles.topText)}
          animation="wave"
          variant="text"
        />
      </div>

      <div>
        <Skeleton
          className={cx(styles.skeleton, styles.bottomText)}
          animation="wave"
          variant="text"
        />
      </div>
    </ButtonBase>
  );
};

PersonaButtonSkeleton.propTypes = {
  className: PropTypes.string,
};

PersonaButtonSkeleton.defaultProps = {
  className: '',
};
